/* tslint:disable */
/* eslint-disable */
/**
 * Organization & Workspace Gateway
 * Methods to manage all organizations and workspaces
 *
 * The version of the OpenAPI document: 22
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OnboardingRecord
 */
export interface OnboardingRecord {
    /**
     * Unique identifier for saved onboarding details
     * @type {string}
     * @memberof OnboardingRecord
     */
    onboardingRecordId: string;
}

export function OnboardingRecordFromJSON(json: any): OnboardingRecord {
    return OnboardingRecordFromJSONTyped(json, false);
}

export function OnboardingRecordFromJSONTyped(json: any, ignoreDiscriminator: boolean): OnboardingRecord {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'onboardingRecordId': json['onboardingRecordId'],
    };
}

export function OnboardingRecordToJSON(value?: OnboardingRecord | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'onboardingRecordId': value.onboardingRecordId,
    };
}

